<div class="content">
  <div class="intositeLoadingInfo">
    <ins-loading-circle [size]="60"></ins-loading-circle>
  </div>
</div>